export default function archivClear() {
  const root = document.getElementById('archiv-data')
  if (root === null) {return}
  const imgs = root.querySelectorAll('img')

  const location = window.location

  if (imgs.length !== 0) {
    imgs.forEach(img => {
      const src = img.src.replace(location, '')
      const old = img.attributes.src.nodeValue

      if (old.startsWith('files/')) {
        img.src = location.origin + '/storage/seasons/archiv/' + old
      }
    })
  }
}